import * as components from './components'

export default [
  {
    path: '/stream/:uuid/degree',
    component: components.StreamDegree,
    name: 'streamDegree',
    props: true,
    meta: {
      title: 'Pragya: Degree Credit Progress'
    }
  },
  {
    path: '/stream/:uuid/career',
    component: components.StreamCareer,
    name: 'streamCareer',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/stream/routes.js